import {
	CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID,
	MORE_MENU_TEST_ID,
} from '../../../ui/more-menu/constants';
import { useAnalyticsEvents } from '../../analytics/generated/use-analytics-events';
import { type CustomizationDataShapes, type ForYouConfig } from '../../types';

export function useNavAnalytics() {
	const { fireEvent } = useAnalyticsEvents();

	const fireViewSideNavEvent = (
		forYou: ForYouConfig,
		sideNavMenuData: CustomizationDataShapes,
		appSpecificItemsList: string[],
		isCustomizationEnabled: boolean,
		hasBottomElem: boolean,
	) => {
		const moreMenuItems = sideNavMenuData.hiddenItemMenuIds.concat(
			sideNavMenuData.hiddenShortcutMenuIds,
		);

		const globalItemsList = [
			...(!forYou.hideForYou ? [forYou.forYouMenuItemId ?? 'global.sidebar.forYou'] : []),
			...(!forYou.hideRecents ? [forYou.recentsMenuItemId ?? 'global.sidebar.recents'] : []),
			...(!forYou.hideStarred ? [forYou.starredMenuItemId ?? 'global.sidebar.starred'] : []),
			...(isCustomizationEnabled
				? [moreMenuItems.length ? MORE_MENU_TEST_ID : CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID]
				: []),
			...(hasBottomElem ? ['global.sidebar.bottomElem'] : []),
		];

		const appShortcutItemsList = sideNavMenuData.visibleShortcutMenuIds;

		fireEvent('ui.sideNav.viewed.sideNavMenu', {
			globalItemsCount: globalItemsList.length,
			globalItemsList,
			appSpecificItemsCount: appSpecificItemsList.length,
			appSpecificItemsList,
			appShortcutItemsCount: appShortcutItemsList.length,
			appShortcutItemsList,
			inMoreItemsCount: moreMenuItems.length,
			inMoreItemsList: moreMenuItems,
		});
	};

	const fireScrollSideNavEvent = (scrollDirection: 'up' | 'down') => {
		fireEvent('ui.sideNav.scrolled.sideNavMenu', {
			scrollDirection,
		});
	};

	return {
		fireViewSideNavEvent,
		fireScrollSideNavEvent,
	};
}
